// FLAGS: personal-data
// Decides which profile fields identify a user to PostHog: id, employer, year of birth, login
// provider and account flags.
export interface User {
  id: string;
  employerId?: string;
  languageCode: string;
  yearOfBirth?: number;
  loginProvider?: string;
  signUpToNewsletter?: boolean;
  isPartner?: boolean;
  createdAt: string;
  isManager: boolean;
  isFocusThemeSet: boolean;
}

// FLAGS: personal-data
// The property set every PostHog event on a logged-in session carries. Adding a field here — a name, an
// email, a theme — widens what a third party holds about an identified user, with no other gate.
export const mapUserToAnalyticsProps = (user: User) => ({
  id: user.id,
  employerId: user.employerId,
  language: user.languageCode,
  yearOfBirth: user.yearOfBirth,
  loginProvider: user.loginProvider ?? "unknown",
  signUpToNewsletter: user.signUpToNewsletter ?? false,
  isFamily: user.isPartner ?? false,
  createdAt: user.createdAt,
  isManager: user.isManager ?? false,
  isFocusThemeSet: user.isFocusThemeSet ?? false,
});
